/**
 * Selection model for the Binom paths workspace (left list + right detail).
 * Mirrors the Voluum 2-pane shell — Binom only needs default-path and
 * group-path; no group-conditions (Binom doesn't expose criteria editing yet).
 *
 * For Media Devoted | Created By Ciro Autiero
 */

export type BinomPathsSelection =
  | { kind: 'default-path'; index: number }
  | { kind: 'group-path'; groupIndex: number; pathIndex: number };

export function defaultPathSelection(index: number): BinomPathsSelection {
  return { kind: 'default-path', index };
}

export function groupPathSelection(
  groupIndex: number,
  pathIndex: number,
): BinomPathsSelection {
  return { kind: 'group-path', groupIndex, pathIndex };
}

export function isDefaultPathSelected(
  selection: BinomPathsSelection,
  index: number,
): boolean {
  return selection.kind === 'default-path' && selection.index === index;
}

export function isGroupPathSelected(
  selection: BinomPathsSelection,
  groupIndex: number,
  pathIndex: number,
): boolean {
  return (
    selection.kind === 'group-path' &&
    selection.groupIndex === groupIndex &&
    selection.pathIndex === pathIndex
  );
}
